module.exports = __webpack_public_path__ + "img/svg-anmated.f013e0a4.svg";